import { Pagination } from '@/domain/entities/Pagination'
import {
  AdditionalInfo,
  AdditionalInfoData,
} from '@/domain/entities/AdditionalInfo'
import { AxiosResponse } from 'axios'
import { BaseResponseMapper } from './Base'

export class AdditionalInfoDataMapper extends BaseResponseMapper {
  public convertAdditionalInfoFromApi(
    result: AxiosResponse<any>
  ): AdditionalInfo {
    const { data } = result
    return new AdditionalInfo(
      data.success,
      data.message,
      new Pagination(
        data.pagination.current_page,
        data.pagination.page_count,
        data.pagination.page_size,
        data.pagination.row_count,
        data.pagination.first_row_on_page,
        data.pagination.last_row_on_page
      ),
      data.data.map(
        (val) =>
          new AdditionalInfoData(
            val.id,
            val.title,
            val.file.code,
            val.is_active,
            val.is_downloadable,
            val.is_recommended,
            val.owner,
            val.file,
            val.image_thumbnail,
            val.image_cover,
            val.created_at,
            val.updated_at,
            val.expireddate
          )
      )
    )
  }
}
